import { render, staticRenderFns } from "./articleattributes.vue?vue&type=template&id=c0b65fd4&"
import script from "../../ts/articleattributes/articleattributes.ts?vue&type=script&lang=js&"
export * from "../../ts/articleattributes/articleattributes.ts?vue&type=script&lang=js&"
import style0 from "../../assets/css/articleattributes/articleattributes.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports